import { Box, Button as MuiButton, Grid, Link, Stack } from "@mui/material";

import React, { useState } from "react";
import { FeedGrid } from "../components/CustomerListFeedGrid";
import { SectionPaper } from "@/components/Paper";
import { useApiClient } from "../../../hooks/useApiClient";
import type { CustomerStatusDataGridRow, FilterCondition } from "../types";
import { FilteringCondition } from "../components/FilteringCondition";
import { GetCustomerListAPI } from "../api";

export const CustomerList: React.FC = () => {
  const [rows, setRows] = useState<CustomerStatusDataGridRow[]>([]);

  // 検索条件の状態管理
  const [filterCondition, setFilterCondition] = useState<FilterCondition>({
    prefectures: [],
    cities: [],
    // 不動産種別
    realEstateTypeTochi: false,
    realEstateTypeKutate: false,
    realEstateTypeTatemono: false,
  });
  const { apiClient } = useApiClient();

  const handleFiltering = async (): Promise<void> => {
    // バリデーションチェック
    if (
      filterCondition.prefectures.length === 0 ||
      filterCondition.cities.length === 0
    ) {
      // バリデーションエラーがある場合は処理を中断
      return;
    }

    const realEstateTypes: string[] = [];
    if (filterCondition.realEstateTypeKutate)
      realEstateTypes.push("CONDOMINIUM");
    if (filterCondition.realEstateTypeTatemono)
      realEstateTypes.push("BUILDING");
    if (filterCondition.realEstateTypeTochi) realEstateTypes.push("LAND");

    const response = await GetCustomerListAPI(
      apiClient,
      "/real-estate-owner-customer-management/customer-list",
      filterCondition.cities,
      filterCondition.prefectures,
      realEstateTypes
    );
    setRows(response);
  };

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs>
          <Stack my={2} direction="row" justifyContent="end" spacing={1}>
            <MuiButton
              variant="contained"
              size="large"
              component={Link}
              href="/customermanagement/excludedcustomerlist"
            >
              対象外顧客一覧
            </MuiButton>
          </Stack>
        </Grid>
      </Grid>

      {/* フィルタ部分 */}
      <FilteringCondition
        filterCondition={filterCondition}
        handleFiltering={() => {
          (async () => {
            await handleFiltering();
          })();
        }}
        setFilterCondition={setFilterCondition}
      />

      <Box sx={{ mt: 3 }} />

      <SectionPaper>
        <form>
          <FeedGrid rows={rows} />
          <Box sx={{ mb: 6 }} />
          <Stack
            direction={"row"}
            spacing={4}
            justifyContent={"center"}
            mb={2}
          />
        </form>
      </SectionPaper>
    </>
  );
};
